import Endpoint from "../../services/api/endpoint";
import { ICustomer } from "../../utils/types/models";
import { createEntityReducer } from "./entityReducer";

export default createEntityReducer<ICustomer>(Endpoint.Customers, Endpoint.CustomersList);